import { FC } from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { STEPS } from "./Types";

interface StepHeaderProps {
  activeStep: number;
  steps?: string[];
}

const StepHeader: FC<StepHeaderProps> = ({ activeStep, steps = STEPS }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
    {steps.map((label, idx) => {
      const isDone = idx < activeStep;
      const isActive = idx === activeStep;
      return (
        <Box key={label} sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
            {isDone ? (
              <CheckCircleIcon sx={{ color: "#1DB980", fontSize: 20 }} />
            ) : (
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                  border: `1.5px solid ${isActive ? "#333" : "#BDBDBD"}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "11px",
                  fontWeight: 700,
                  color: isActive ? "#333" : "#BDBDBD",
                }}
              >
                {idx + 1}
              </Box>
            )}
            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: isActive ? 700 : 500,
                letterSpacing: "0.3px",
                color: isActive ? "#222" : "#9E9E9E",
                textTransform: "uppercase",
                whiteSpace: "nowrap",
              }}
            >
              {label}
            </Typography>
          </Box>
          {idx < steps.length - 1 && (
            <Box sx={{ width: 36, height: "1px", backgroundColor: "#DADADA", mx: 1.5 }} />
          )}
        </Box>
      );
    })}
  </Box>
);

export default StepHeader;